export default __webpack_public_path__ + "static/card_reader_w.16628106687eb85f31c943c0933051ed.png";